<template>
  <iframe style="width: 100%; height: 100%; padding-bottom: 50px;
 border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 0 8px rgba(0,0,0,0.06);" src="/help/index.html" />
</template>

<script>
export default {
  name: 'CommerciaVueHelp',
  data () {
    return {}
  }
}
</script>
